// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckableTagFilterGroup_container__1j49t","title":"CheckableTagFilterGroup_title__3Ld6d"};